__turbopack_context__.v({
  "main": "Banner-module__-O-kWG__main",
  "subtitle": "Banner-module__-O-kWG__subtitle",
  "title": "Banner-module__-O-kWG__title",
});
